var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.module && _vm.module.show)?_c('CardBody',{attrs:{"html":_vm.module.html}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }